import React, { useEffect, useState } from "react";
import { ArrowRight, Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { getWishlist } from "../core/services/wishlistService";
import ProductCard from "../shared/ProductCard";
import { useAuth } from "../contexts/AuthContext";
import { useWishlist } from "../contexts/WishlistContext";

export default function Wishlist() {
  const { token } = useAuth();
  const { wishlistIds, guestWishlist } = useWishlist();
  const [products, setProducts] = useState(guestWishlist);
  useEffect(() => {
    if (!token) {
      setProducts(guestWishlist);
      return;
    }
    let alive = true;
    getWishlist()
      .then((data) => {
        if (alive) setProducts(data.wishlist?.products || []);
      })
      .catch(() => {
        if (alive) setProducts([]);
      });
    return () => {
      alive = false;
    };
  }, [token, wishlistIds, guestWishlist]);
  return (
    <main className="page-shell content-page wishlist-page">
      <div className="breadcrumbs">
        <Link to="/">Home</Link>
        <span>/</span>
        <span>Wishlist</span>
      </div>
      <div className="page-title-row">
        <div>
          <p className="eyebrow">YOUR FAVORITES</p>
          <h1>Wishlist</h1>
          <p className="wishlist-page__subtitle">Keep your favorite finds close and come back whenever you’re ready.</p>
        </div>
        <div className="wishlist-page__count">
          <Heart size={19} />
          <strong>{products.length}</strong>
          <span>{products.length === 1 ? "saved item" : "saved items"}</span>
        </div>
      </div>
      {products.length ? (
        <section className="wishlist-panel">
          <div className="wishlist-panel__heading">
            <div>
              <h2>Saved for later</h2>
              <p>Your picks are right here when you need them.</p>
            </div>
            <Link to="/shop" className="wishlist-panel__shop-link">
              Discover more <ArrowRight size={15} />
            </Link>
          </div>
          <div className="product-grid wishlist-grid">
            {products.map((product) => (
              <ProductCard product={product} key={product._id} />
            ))}
          </div>
        </section>
      ) : (
        <div className="empty-state wishlist-empty">
          <span className="empty-state__icon"><Heart /></span>
          <p className="eyebrow">A LITTLE SPACE FOR YOUR FAVORITES</p>
          <h2>Nothing saved just yet.</h2>
          <p>Tap the heart on anything you’d like to come back to.</p>
          <Link to="/shop" className="button button--primary">
            Explore the shop <ArrowRight size={17} />
          </Link>
        </div>
      )}
    </main>
  );
}
